import styled from 'styled-components';
import { body2, colors, spacing, subtleShadow } from 'ui/theme';
import { ANNOUNCEMENT_VARIANTS } from './constants';

export const LabelContainer = styled.div`
  margin-right: auto;
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const ActionButtonContainer = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const Container = styled.div`
  ${body2}
  gap: ${spacing.threeQuarter};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${subtleShadow}
  > * {
    flex: 1 1 max-content;
    &:only-child {
      flex: 0 1 max-content;
    }
  }
  > ${LabelContainer} {
    flex: 0 1 max-content;
  }
  > ${ActionButtonContainer} {
    flex: 0 1 max-content;
  }
  &[data-variant='${ANNOUNCEMENT_VARIANTS.DEFAULT}'] {
    background: ${colors.salmon10};
    border-bottom: solid ${spacing.eighth} transparent;
    color: ${colors.warning100};
    padding: ${spacing.threeQuarter} ${spacing.base};
  }
  &[data-variant='${ANNOUNCEMENT_VARIANTS.BOSS_DEFAULT}'] {
    background: ${colors.grey5};
    border-bottom: solid ${spacing.eighth} ${colors.negative100};
    color: ${colors.secondaryText};
    padding: ${spacing.half} ${spacing.plusHalf};
  }
  &[data-variant='${ANNOUNCEMENT_VARIANTS.BOSS_IMPERSONATING}'] {
    background: ${colors.negative100};
    border-bottom: solid ${spacing.eighth} transparent;
    color: ${colors.white};
    padding: ${spacing.half} ${spacing.plusHalf};
  }
  &[data-variant='${ANNOUNCEMENT_VARIANTS.INFO}'] {
    color: ${colors.cyan100};
    background: ${colors.backgroundInfoSubtle};
    padding: ${spacing.half} ${spacing.plusHalf};
    border-top: ${spacing.single} solid ${colors.cyan20};
    border-bottom: solid ${spacing.single} ${colors.cyan20};
  }
`;
